import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getIqamaData } from "./../../../../../store/Api";

import ListPhysicalCardList from "./ListPhysicalCardList";
import nodeinstance from "../../../../../nodeInstance";

export default function IqamaPhysicalCard(props) {
  const IqamaData = useSelector((state) => state.iqamaData);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  // useEffect(() => {
  //   dispatch(getIqamaData(token));
  // }, []);

  const [muqeemData, setMuqeemData] = useState();

  const [trigger, setTrigger] = useState(false);

  const MuqeemResponse = async () => {
    try {
      const response = await nodeinstance.get(
        `/iqama/iqammaDone/${"Physical"}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        console.log("....respone.....", response);

        setMuqeemData(response.data);
        // setLen(response.data.data.length);
      }
    } catch (error) {
      console.log("error to be seen here in console", error);
    }
  };

  const updateData = () => {
    // dispatch(getIqamaData(token));
    MuqeemResponse();
  };

  // useEffect(() => {
  //   MuqeemResponse();
  // }, [trigger]);

  return (
    <>
      <ListPhysicalCardList
        titles={[
          "S.NO.",
          "EMPLOYEE ID",
          "IQAMA NUMBER",
          "IQAMA Received Date",
          "IQAMA ISSUE DATE (G)",
          "IQAMA EXPIRY DATE (G)",
          "IQAMA EXPIRY DATE (H)",
          "AGING DAYS",
          "ISSUE CATEGORY",
          "CARD APPLY DATE",
          "CARD RECEIVED DATE",
          "INSTANCE",
          "CARD STATUS",
          "",
          "Action",
        ]}
        // list={muqeemData}
        // loading={loading}
        token={token}
        setTrigger={setTrigger}
        trigger={trigger}
        updateData={updateData}
      />
    </>
  );
}
